export enum ESmartPlugType {
  SPECIFIC = "SPECIFIC",
  GENERAL = "GENERAL",
}
